import React from 'react'
import IconButton from 'material-ui/IconButton'
import './buttonFavoriteStyle.css'

const ButtonFavorite = ({ onClick, isFollow, ...props }) => (
  <IconButton {...props} onClick={onClick}>
    <i className={"material-icons icon "+ (isFollow ? 'isFollow' : '')}>{isFollow ? 'favorite' : 'favorite_border'}</i>
  </IconButton>
)
ButtonFavorite.defaultProps = {
  onClick: () => {},
  isFollow: false
}

export default ButtonFavorite



// WEBPACK FOOTER //
// ./src/components/ButtonFavorite.js